import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Table,Tbody, Td, Thead, Tr } from 'react-super-responsive-table';

const DischargedStudentFees = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px'
  );

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const location = useLocation();
  const { student_id, selectedData = [], studentName = '' } = location.state || {};

  return (
    <>
      <style>
        {`
          @media (max-width: 767.98px) {
            .responsive-btn {
              margin-top: 5px !important;
              padding: 0.25rem 0.5rem !important;
              font-size: 0.875rem !important;
            }
          }
        `}
      </style>
      <div style={{ marginLeft }}>
            <div
          className="container-fluid p-0"
          style={{ marginTop: window.innerWidth < 768 ? '55px' : '-12px' }}
        >
             <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2>  Fees Details for <strong>{studentName}</strong></h2>
          </div>
          </div>
        <div className="container mt-4">
            <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0 mt-4">
            <Thead className="bg-dark text-white">
              <Tr>
                <th>Transaction Amount (₹)</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Transaction Date</th>
                  <th>Payment Method</th>
                  <th>Fees Status</th>
                </Tr>
              </Thead>
              <Tbody>
                {!student_id || selectedData.length === 0 ? (
                  <Tr>
                    <Td colSpan="6" className="text-danger text-center py-4">
                      No data found
                    </Td>
                  </Tr>
                ) : (
                  selectedData
                    .filter(
                      (fee) =>
                        fee.fees_status === 'pending' ||
                        fee.fees_status === 'complete'
                    )
                    .map((fee) => (
                      <Tr key={fee.id}>
                        <Td>₹ {fee.transaction_amount || fee.amount}</Td>
                        <Td>{new Date(fee.start_date).toLocaleDateString('en-GB')}</Td>
                        <Td>{new Date(fee.end_date).toLocaleDateString('en-GB')}</Td>
                        <Td>
                          {fee.transaction_date
                            ? new Date(fee.transaction_date).toLocaleDateString('en-GB')
                            : '-'}
                        </Td>
                        <Td>{fee.payment_method || '-'}</Td>
                        <Td>{fee.fees_status}</Td>
                      </Tr>
                    ))
                )}
              </Tbody>
            </Table>
          </div>
        </div>
    </>
  );
};

export default DischargedStudentFees;
